<script lang="ts" setup>
import IconSvgBase from '~theme/components/atoms/icons/IconSvgBase.vue';

export type Direction = 'up' | 'right' | 'down' | 'left';
withDefaults(
  defineProps<{
    direction?: Direction;
  }>(),
  { direction: 'up' }
);
</script>

<template>
  <IconSvgBase
    :class="[$style.icon, $style[`icon--${direction}`]]"
    :view-width="10"
    :view-height="7"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      :class="$style.path"
      d="M4.99999 0.500238C5.25599 0.500238 5.51199 0.598238 5.70699 0.793238L9.70699 4.79324C10.098 5.18424 10.098 5.81624 9.70699 6.20724C9.31599 6.59824 8.68399 6.59824 8.29299 6.20724L4.98799 2.90224L1.69499 6.08224C1.29599 6.46524 0.664994 6.45424 0.280994 6.05724C-0.103005 5.66024 -0.0920057 5.02624 0.304995 4.64324L4.30499 0.781238C4.49999 0.593238 4.74999 0.500238 4.99999 0.500238Z"
    />
  </IconSvgBase>
</template>

<style lang="scss" module>
@layer element {
  .path {
    fill: currentColor;
  }

  .icon {
    width: 1em;
    height: 1em;
    transition: transform $transition-base;

    &--right {
      transform: rotate(90deg);
    }
    &--down {
      transform: rotate(180deg);
    }
    &--left {
      transform: rotate(270deg);
    }
  }
}
</style>
